<template>
    <div>
        <MenuAccount_Main/>
        <IncomeStatementList/>
    </div>
</template>

<script>

import MenuAccount_Main from '@/components/menuadmin/account/accountheader/MenuAccount_Main.vue'
import IncomeStatementList from '@/components/menuadmin/account/accountreport/IncomeStatementList.vue'
export default {
    name:'incomeStatement',
    components:{
        MenuAccount_Main,
        IncomeStatementList,
    },
}
</script>